import { lazy, Suspense } from 'react';

const ImageViewerIAComponent = lazy(() =>
  import('./ImageViewerIA').then((mod) => ({ default: mod.ImageViewerIA }))
);

function ImageViewerIAFallback() {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#1e1e1e',
        borderRadius: '4px',
        color: '#fff',
      }}
    >
      <div>
        <div className="spinner-border text-light mb-2" role="status">
          <span className="visually-hidden">Loading viewer...</span>
        </div>
        <div style={{ fontSize: '14px', opacity: 0.7 }}>Loading image viewer...</div>
      </div>
    </div>
  );
}

interface ImageViewerIALazyProps {
  file: { key: string; compressedSigned?: string; fileKeySigned?: string; compressed?: string; fileKey?: string; url?: string };
  createUserAnnotations?: (...args: unknown[]) => unknown;
}

export function ImageViewerIALazy(props: ImageViewerIALazyProps) {
  return (
    <Suspense fallback={<ImageViewerIAFallback />}>
      <ImageViewerIAComponent {...props} />
    </Suspense>
  );
}

export default ImageViewerIALazy;
